var _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.15 166.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #fff;\n        stroke-width: 2.77px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #fff0d7;\n      }\n\n      .cls-2 {\n        stroke: #ffc557;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4.15px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0,
    width: 166.15,
    height: 166.15,
    rx: 44.31,
    ry: 44.31,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.38,
    y: 1.38,
    width: 163.38,
    height: 163.38,
    rx: 42.92,
    ry: 42.92,
    shapeRendering: "crispEdges"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 80.52,
    cy: 87.71,
    r: 36.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 80.52,
    cy: 87.71,
    r: 23.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 80.52,
    cy: 87.71,
    r: 10.71
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "121.49 46.45 107.63 60.31 109.5 38.92 123.36 25.06 121.49 46.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "129.31 58.73 143.17 44.87 121.78 46.74 107.92 60.6 129.31 58.73"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 80.52,
    y1: 87.71,
    x2: 121.95,
    y2: 46.28
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMission);
export default __webpack_public_path__ + "static/media/icon-mission.bce433c94a178f9cae180be7ede33b0c.svg";
export { ForwardRef as ReactComponent };